import { render, staticRenderFns } from "./ProgressDetail.vue?vue&type=template&id=56164f46"
import script from "./ProgressDetail.vue?vue&type=script&lang=js"
export * from "./ProgressDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports